module.exports = __webpack_public_path__ + "static/media/FailedStatus.d2c0f23c.png";